<div class="global-overlay-page">
  <div style="display: flex; justify-content: center;padding:20px;">
    <div style="width: 100%">
      <div class="menu">
        <div class="filter-input-container" (click)="$event.stopPropagation()">
          <input #filterInput type="text" (keyup)="filter($event)" [value]="clientFilter" placeholder="Filter clients" />
          @if (showTagSuggestions) {
            <div class="tag-suggestion-dropdown">
              @for (tag of tagSuggestions; track tag.id) {
                <div class="tag-suggestion-item" (click)="selectTagSuggestion(tag, $event)">
                  <mat-icon class="tag-suggestion-icon">label</mat-icon>
                  {{ tag.tag }}
                </div>
              }
            </div>
          }
        </div>
        <div class="toolbarAlwaysOn toolbar">
          <a (click)="newClient()">New Client</a>
          <a (click)="bulkImport()">Import Clients</a>
        </div>
        <mat-checkbox [checked]="parents" (change)="onCheckboxChange($event)">Parents</mat-checkbox><mat-icon
          class="column-icon family-icon" title="Parent Organization">family_restroom</mat-icon>
        @if (selectedTags.length) {
          <div class="tag-filter-area" (click)="$event.stopPropagation()">
            @for (tag of selectedTags; track tag.id) {
              <div class="selected-tag-chip">
                {{ tag.tag }}<span class="chip-remove" (click)="removeTagFilter(tag.id)">&#x2715;</span>
              </div>
            }
          </div>
        }
        <div class="bulk-actions-area" (click)="$event.stopPropagation()">
          @if (selectedCount > 0) {
            <span class="selection-count">{{ selectedCount }} selected</span>
            <div class="bulk-actions-container">
              <button class="bulk-actions-btn" (click)="openBulkActions($event)">
                Bulk actions <mat-icon class="bulk-chevron">expand_more</mat-icon>
              </button>
              @if (showBulkActionsMenu) {
                <div class="bulk-actions-menu">
                  <div class="bulk-menu-item" (click)="openBulkTagDialog()">
                    <mat-icon class="bulk-menu-icon">label</mat-icon> Edit Tags
                  </div>
                  <div class="bulk-menu-item" (click)="openUpdateContract()">
                    <mat-icon class="bulk-menu-icon">description</mat-icon> Update Contract
                  </div>
                  <div class="bulk-menu-item" (click)="openBulkCodeDialog()">
                    <mat-icon class="bulk-menu-icon">vpn_key</mat-icon> Add Code
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
      <mat-table #table [dataSource]="loading ? [] : dataSource" matSort>
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              [checked]="allSelected"
              [indeterminate]="someSelected"
              (change)="toggleSelectAll()"
              (click)="$event.stopPropagation()">
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-checkbox
              [checked]="isSelected(element.id)"
              (change)="toggleSelectClient(element.id)"
              (click)="$event.stopPropagation()">
            </mat-checkbox>
          </mat-cell>
        </ng-container>
        @for (column of columnNames; track column) {
        <ng-container matColumnDef="{{ column.id }}">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ column.value }}</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element[column.id] }}</mat-cell>
        </ng-container>
        }
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Client </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.name }}
            @if (element.is_parent) {
            <mat-icon class="column-icon family-icon" title="Parent Organization">family_restroom</mat-icon>
            }
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="parent_name">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Parent </mat-header-cell>
          <mat-cell *matCellDef="let element">
            @if (element.parent_name) {
            {{ element.parent_name }} <mat-icon class="column-icon family-icon"
              title="Parent Organization">family_restroom</mat-icon>
            }
            @if (!element.parent_name) {
            <span class="no-parent-label">No Parent</span>
            }
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="tag_count">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Tags </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="tag-inline-container">
              @for (tag of getVisibleTags(element.tags); track tag) {
                <span class="tag-pill">{{ tag }}</span>
              }
              @if (getOverflowCount(element.tags) > 0) {
                <div class="tag-overflow-container"
                  (mouseenter)="hoveredTagClientId = element.id"
                  (mouseleave)="hoveredTagClientId = null">
                  <span class="tag-overflow-badge">
                    +{{ getOverflowCount(element.tags) }}<mat-icon class="tag-overflow-icon">label</mat-icon>
                  </span>
                  @if (hoveredTagClientId === element.id) {
                    <div class="tag-popup">
                      @for (tag of getOverflowTags(element.tags); track tag) {
                        <div class="tag-popup-item">{{ tag }}</div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="user_count">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Users </mat-header-cell>
          <mat-cell *matCellDef="let element" (click)="loadUsers(element.id)">
            {{ element.user_count }}
            <mat-icon class="column-icon">people</mat-icon>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="code_count">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Codes </mat-header-cell>
          <mat-cell *matCellDef="let element" (click)="loadCodes(element.id)">
            {{ element.code_count }}
            <mat-icon class="column-icon key-icon">abc</mat-icon>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="action-container" (mouseleave)="onMouseLeave()" (mouseenter)="onMouseEnter(element.id)">
              <a class="menu-trigger" (click)="toggleMenu(element.id, $event)"
                [class.active]="activeMenuId === element.id">
                <mat-icon>more_vert</mat-icon>
              </a>
              <div class="row-toolbar" [class.visible]="activeMenuId === element.id">
                <a class="action-btn" (click)="loadActionReport(element.id)">Actions</a>
                <a class="action-btn" (click)="loadCodes(element.id)">Codes</a>
                <a class="action-btn" (click)="loadReports(element.id)">Completion</a>
                <a class="action-btn" (click)="editClient(element.id)">Edit</a>
                <a class="action-btn" (click)="downloadFeedback(element.id)">Feedback</a>
                <a class="action-btn" (click)="loadUsers(element.id)">Users</a>

              </div>
            </div>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      @if (loading) {
      <div class="skeleton-container">
        @for (row of skeletonRows; track $index) {
        <div class="skeleton-row-flex">
          @for (weight of row; track $index) {
          <div class="skeleton-bar" [style.flex-grow]="weight"></div>
          }
        </div>
        }
      </div>
      }
      <div style="display: flex; justify-content: center;">
        <mat-paginator [length]="count" [pageIndex]="page" [pageSize]="size" (page)="onPaginateChange($event)"
          showFirstLastButtons hidePageSize="true"></mat-paginator>
      </div>
    </div>


  </div>

  <!-- Modal Overlay for Bulk Client -->
  @if (bulk) {
  <div class="modal-overlay">
    <div class="modal-content-wrapper">
      <app-bulk-client (close)="closeBulkDetail($event)" [closeBulk]="closeBulk"></app-bulk-client>
    </div>
  </div>
  }

  <!-- Bulk Contract Dialog -->
  @if (showBulkContractDialog) {
    <app-bulk-contract-dialog
      [selectedClientIds]="selectedClientIds"
      [selectedClients]="selectedClients"
      (close)="showBulkContractDialog = false"
      (applied)="showBulkContractDialog = false; fetchClients()">
    </app-bulk-contract-dialog>
  }

  <!-- Bulk Tag Dialog -->
  @if (showBulkTagDialog) {
    <app-bulk-tag-dialog
      [selectedClientIds]="selectedClientIds"
      [selectedClients]="selectedClients"
      (close)="showBulkTagDialog = false"
      (applied)="showBulkTagDialog = false; fetchClients()">
    </app-bulk-tag-dialog>
  }

  <!-- Bulk Code Dialog -->
  @if (showBulkCodeDialog) {
    <app-bulk-code-dialog
      [selectedClientIds]="selectedClientIds"
      [selectedClients]="selectedClients"
      (close)="showBulkCodeDialog = false"
      (applied)="showBulkCodeDialog = false; fetchClients()">
    </app-bulk-code-dialog>
  }

  <!-- Modal Overlay for Client Detail - Moved Outside Flex Container -->
  @if (client) {
  <div class="modal-overlay">
    <div class="modal-content-wrapper">
      <app-client-detail [client]="client" [closeClient]="closeClient"
        (close)="closeClientDetail($event)"></app-client-detail>
    </div>
  </div>
  }
